import React, { useEffect, useState } from 'react'
import SelfTaskTrackManagerHardware from '../../SelfTaskTrack/SelfTaskTrackManagerHardware'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDescriptionTasksProjectTracking } from '../../../../../../store/slices/DescriptionTask'
import { fetchHardwareProjectTracking } from '../../../../../../store/slices/hardwareDescriptionSlice'
import { fetchEmployees } from '../../../../../../store/slices/employeeSlice'
import OpTaskTrackHardware from '../OpTaskTrackHardware'
import OPHardwareOngoingPM from '../../../OperationToManagerAccess/OPProjectOngoingPM/OPHardwareOngoingPM'

const HardwareTrack = ({
  selectedResource,
  setIsLoading,
  showListState,
  isViewOnly = false,
}) => {

  const dispatch = useDispatch();

  const { employees } = useSelector((state) => state.employees);
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const hardwareRowOngoing = useSelector(
    (state) => state.operationFeature.hardwareRowOngoing
  );
  console.log("selectedResource selectedResource", selectedResource)
  console.log("matchedEmployees hardwareRowOngoing", hardwareRowOngoing)
  useEffect(() => {
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchEmployees());
  }, [dispatch]);

  const handlerefresh = () => {
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
  }

  const [matchedHardwarePartsAllProject, setmatchedHardwarePartsAllProject] = useState([])
  const [matchedDescriptionsProjects, setmatchedDescriptionsProjects] = useState([])
  const [aggregateProgressMap, setAggregateProgressMap] = useState({});


  useEffect(() => {
    const matchedHardwarePartsAllProject =
      hardwareProjectTracking?.filter(
        (entry) => entry?.projectid === hardwareRowOngoing?._id
      ) || [];
    setmatchedHardwarePartsAllProject(matchedHardwarePartsAllProject)

    const matchedDescriptionsProjects =
      descriptionProjectTracking?.filter(
        (entry) => entry?.projectid === hardwareRowOngoing?._id
      ) || [];
    setmatchedDescriptionsProjects(matchedDescriptionsProjects)
  }, [hardwareProjectTracking, descriptionProjectTracking, hardwareRowOngoing])

  console.log("matchedEmployees matchedHardwarePartsAllProject", matchedHardwarePartsAllProject)
  console.log("matchedDescriptionsProjects finalDataCalculated", matchedDescriptionsProjects)

  const [empAllData, setEmpAllData] = useState([]);

  useEffect(() => {
    if (!employees?.length) return;
    const assignedEmails = hardwareRowOngoing.Assignedperson.map(p => p.email);
    const matchedEmployees = employees.filter(emp =>
      assignedEmails.includes(emp?.EmpEmail)
    );
    setEmpAllData(matchedEmployees);
  }, [employees, hardwareRowOngoing]);

    const [finalDataCalculated, setFinalDataCalculated] = useState([])
    const [managerSelfPartIdsByAssemblyDescription, setManagerSelfPartIdsByAssemblyDescription] = useState({})
  console.log("finalDataCalculated", finalDataCalculated)

  useEffect(() => {
    // 1️⃣ Group by assemblypartdescription
    const GroupByPartsByAssemblyPartDescription =
      matchedHardwarePartsAllProject.reduce((acc, part) => {
        if (!acc[part.assemblepartdescription]) {
          acc[part.assemblepartdescription] = [];
        }
        acc[part.assemblepartdescription].push(part);
        return acc;
      }, {});

    // 2️⃣ Reset hardwarePartsOngoing
    let updatedEmployees = empAllData.map(emp => ({
      ...emp,
      hardwarePartsOngoing: [],
      hardwareDescriptionsOngoing: []
    }));

    const pmEmp = updatedEmployees.find(e => e.customRoles?.includes("project manager"));
    const managerPartIdsMap = {};

    Object.entries(GroupByPartsByAssemblyPartDescription).forEach(([desc, parts]) => {
      if (!pmEmp) return;

      // PM parts (include actual PM)
      const pmParts = parts.filter(p => {
        const owner = updatedEmployees.find(e => e._id === p.taskownerid);
        return owner?.customRoles?.includes("project manager");
      });

      // Operations-only parts
      const opParts = parts.filter(p => {
        const owner = updatedEmployees.find(e => e._id === p.taskownerid);
        return owner?.customRoles?.includes("operations") && !owner?.customRoles?.includes("project manager");
      });

      // When both PM and OP have this part, manager's self task(s) should also complete when OP part is completed (manager part may be hidden in "Self" due to lower quantity)
      if (pmParts.length && opParts.length) {
        managerPartIdsMap[desc] = pmParts.map(p => p._id).filter(Boolean);
      }

      // 3️⃣ Operations always keep their own parts
      opParts.forEach(part => {
        const opEmp = updatedEmployees.find(e => e._id === part.taskownerid);
        if (opEmp) opEmp.hardwarePartsOngoing.push(part);
      });

      // 4️⃣ Decide PM entry
      if (pmParts.length && opParts.length) {
        const highestPM = pmParts.reduce((a, b) =>
          Number(b.quantity) > Number(a.quantity) ? b : a
        );

        const highestOP = opParts.reduce((a, b) =>
          Number(b.quantity) > Number(a.quantity) ? b : a
        );

        const finalPart =
          Number(highestOP.quantity) > Number(highestPM.quantity)
            ? highestOP
            : highestPM;

        pmEmp.hardwarePartsOngoing.push({ ...finalPart });

      } else if (!pmParts.length && opParts.length) {
        // 🔥 THIS WAS MISSING → "three"
        const highestOP = opParts.reduce((a, b) =>
          Number(b.quantity) > Number(a.quantity) ? b : a
        );

        pmEmp.hardwarePartsOngoing.push({ ...highestOP });

      } else if (pmParts.length) {
        const highestPM = pmParts.reduce((a, b) =>
          Number(b.quantity) > Number(a.quantity) ? b : a
        );

        pmEmp.hardwarePartsOngoing.push({ ...highestPM });
      }
    });

    setManagerSelfPartIdsByAssemblyDescription(managerPartIdsMap);

    const GroupByDescription =
      matchedDescriptionsProjects.reduce((acc, part) => {
        if (!acc[part.description]) {
          acc[part.description] = [];
        }
        acc[part.description].push(part);
        return acc;
      }, {});
    Object.entries(GroupByDescription).forEach(
      ([desc, parts]) => {
        // 🔹 PM parts
        const pmParts = parts.filter(p => {
          const owner = updatedEmployees.find(e => e._id === p.taskownerid);
          return owner?.customRoles?.includes("project manager");
        });
        // 🔹 Operations-only parts
        const opParts = parts.filter(p => {
          const owner = updatedEmployees.find(e => e._id === p.taskownerid);
          return (
            owner?.customRoles?.includes("operations") &&
            !owner?.customRoles?.includes("project manager")
          );
        });
        const highestPM = pmParts.length
          ? pmParts.reduce((a, b) =>
            b.value > a.value ? b : a
          )
          : null;

        const highestOP = opParts.length
          ? opParts.reduce((a, b) =>
            b.value > a.value ? b : a
          )
          : null;

        // 3️⃣ Operations always keep their own parts
        opParts.forEach(part => {
          const opEmp = updatedEmployees.find(
            e => e._id === part.taskownerid
          );
          if (opEmp) {
            opEmp.hardwareDescriptionsOngoing.push(part);
          }
        });

        // 4️⃣ Resolve PM assignment using explicit rules
        const pmEmp = updatedEmployees.find(e =>
          e.customRoles?.includes("project manager")
        );
        if (!pmEmp) return;

        // 🔹 RULE 1: PM has NO part but OP HAS → clone OP
        if (!highestPM && highestOP) {
          pmEmp.hardwareDescriptionsOngoing.push({ ...highestOP });
          return;
        }

        // 🔹 RULE 2: PM ≥ OP → keep PM
        if (
          highestPM &&
          (!highestOP || highestPM.value >= highestOP.value)
        ) {
          const pmOwner = updatedEmployees.find(
            e => e._id === highestPM.taskownerid
          );
          if (pmOwner) {
            pmOwner.hardwareDescriptionsOngoing.push(highestPM);
          }
          return;
        }

        // 🔹 RULE 3: OP > PM → clone OP
        if (
          highestPM &&
          highestOP &&
          highestOP.value > highestPM.value
        ) {
          pmEmp.hardwareDescriptionsOngoing.push({ ...highestOP });
        }
      }
    );

    // 5️⃣ Optional: Deduplicate PM parts by assemblypartdescription
    updatedEmployees.forEach(emp => {
      emp.hardwareDescriptionsOngoing = emp.hardwareDescriptionsOngoing.filter(
        (v, i, self) =>
          i ===
          self.findIndex(
            x =>
              x.description ===
              v.description
          )
      );
    });
    setFinalDataCalculated(updatedEmployees);
  }, [empAllData, matchedHardwarePartsAllProject, matchedDescriptionsProjects]);

  return (
    <div>
      {selectedResource.label === "Self" ? (
        <SelfTaskTrackManagerHardware
          handlerefresh={handlerefresh}
          employees={employees}
          setIsLoading={setIsLoading}
          setAggregateProgressMap={
            setAggregateProgressMap
          }
          aggregateProgressMap={aggregateProgressMap}
          row={hardwareRowOngoing}
          showListState={showListState}
          matchedHardwarePartsManager={
            finalDataCalculated?.find(person => person?._id === selectedResource?.employee?._id)
              ?.hardwarePartsOngoing || []
          }
          managerSelfPartIdsByAssemblyDescription={managerSelfPartIdsByAssemblyDescription}
          matchedHardwareDescriptionsPartsManager={
            finalDataCalculated?.find(person => person?._id === selectedResource?.employee?._id)
              ?.hardwareDescriptionsOngoing || []
          }
          allDescriptionEntriesForProject={matchedDescriptionsProjects}
          isViewOnly={isViewOnly}
        />
      ) : (
        <>
          {showListState === "tasktable" && (
            <OpTaskTrackHardware
              matchedHardwarePartsOP={
                finalDataCalculated?.find(person => person?._id === selectedResource?.employee?._id)
                  ?.hardwarePartsOngoing || []
              }
              row={hardwareRowOngoing}
              setIsLoading={setIsLoading}
              managerSelfPartIdsByAssemblyDescription={managerSelfPartIdsByAssemblyDescription}
              isViewOnly={isViewOnly}
            />
          )}
          {showListState === "otherexpenses" && (
            <OPHardwareOngoingPM
              refresh={handlerefresh}
              showListState="otherexpenses"
              row={hardwareRowOngoing}
              index={0}
              hardwareProjectTrackingParts={[]}
              hardwareDescriptions={
                finalDataCalculated?.find(person => person?._id === selectedResource?.employee?._id)
                  ?.hardwareDescriptionsOngoing || []
              }
              loggedUser={selectedResource?.employee}
              setIsLoading={setIsLoading}
              isViewOnly={isViewOnly}
            />
          )}
        </>
      )}
    </div>
  )
}

export default HardwareTrack
